// React
import { useState, useEffect } from "react";

// OpenLayers
import OlMap from "ol/Map";
import { transform } from "ol/proj";

// jQuery
import $ from "jquery";

// Models
import Locale from "lib/interfaces/locale";

// Tools
import { assetURL } from "lib/utilities/asset";
import { getLocaleString } from "lib/localization/vendor";
import { getOffsetBottomPixels } from "lib/utilities/misc";

import "styles/css/LocationSelect.scss";

interface LocationSelectProps {
	olMap:OlMap
}

export default function LocationSelect({olMap}:LocationSelectProps) {
	const mapConfig:any = olMap.get("opus-config");
	
	// Initialize
	useEffect(() => {
		// Relies on #location-select being available
		setTimeout(() => adjust(), 100);
		setTimeout(() => adjust(), 250);
		setTimeout(() => adjust(), 500);
	}, [olMap]);
	
	// On dimensions changed
	useEffect(() => {
		adjust();
	}, [_dimensions]);
	
	const shouldShow = ():boolean => !(_dimensions.width < 340 || _dimensions.height < 400);
	
	const adjust = () => {
		/*const width:number = _dimensions.width;
		const height:number = _dimensions.height;
		
		const paddingLeft:number = ($("#base-map-switcher").position()?.left || 40) + (_dimensions.width > 400 ? 15 : 10);
		const left:number = $("#base-map-switcher").width() + paddingLeft;
		
		$("#location-select").css("left", left);
		
		const bmBottom:number = getOffsetBottomPixels("#base-map-switcher") + 60;
		
		if(bmBottom) {
			if(_dimensions.width < 500 || _dimensions.height < 510)
				$("#location-select").css("bottom", (bmBottom-16) + "px");
			else
				$("#location-select").css("bottom", (bmBottom-5) + "px");
		}*/
	}
	
	function getUserLocation(): Promise<GeolocationPosition> {
		return new Promise((resolve, reject) => {
			navigator.geolocation.getCurrentPosition(
				position => resolve(position),
				error => reject(error)
			);
		});
	}
	
	const onClicked = () => {
		getUserLocation()
		.then(position => {
			const coords = transform(
				[position.coords.longitude, position.coords.latitude],
				"EPSG:4326", // lat long
				mapConfig.epsgCodeView
			);
			
			olMap.getView().setCenter(coords);
			olMap.getView().setZoom(17);
		})
		.catch(error => {
			_ui.showNotice(getLocaleString('locreqerr', [error]));
			console.log(error);
		});
	}
	
	if(!shouldShow())
		return;
	
	return (
		<div id="location-select" className="location-select" onClick={onClicked}>
			<img src={assetURL(`assets/images/location.png`)} />
		</div>
	);
}